import React, { useContext } from 'react';
import { useLoader } from '../api/useLoader';
import { PraksisstedApiContext } from '../api/PraksisstedApiContext';
import { useParams } from 'react-router-dom';
import Spinner from '../components/spinner/spinner';
import PageLayout from '../pagelayout';
import StudiestedUserprofile from './studiestedUserprofile';
import { useIntl } from 'react-intl';
import translations from './userprofile.i18n';
import Activities from './activities.psa';

const StudiestedbrukerprofilPage: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { studiestedApi } = useContext(PraksisstedApiContext);
  const { id } = useParams<{ id: string }>();

  const { data } = useLoader(
    () =>
      studiestedApi.studiestedbrukerprofilIdGet({
        pathParams: { id: id as string },
      }),
    [id],
    true,
    true,
  );

  const { formatMessage } = useIntl();
  const labels = {
    title: formatMessage(
      { id: translations.titleStudiested.id },
      {
        institusjon: data && data.studiestedNavn,
      },
    ),
    subtitle: formatMessage({ id: translations.subtitle.id }),
    tilbake: formatMessage({ id: translations.tilbake.id }),
    lagret: formatMessage({ id: translations.lagret.id }),
  };

  if (!data || !id) {
    return <Spinner />;
  }

  const navn = `${data.bruker.fornavn} ${data.bruker.etternavn}`;

  return (
    <PageLayout isIndented title={labels.title} subtitle={labels.subtitle}>
      <StudiestedUserprofile brukerprofil={data} />
      <Activities
        userProfileId={id}
        userName={navn}
        isSelf={false}
        isPraksisstedBruker={false}
      />
    </PageLayout>
  );
};

export default StudiestedbrukerprofilPage;
